class DetailsModal extends HTMLElement {
  constructor() {
    super()
    this.detailsContainer = this.querySelector('details')
    this.summaryToggle = this.querySelector('summary')

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close())
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this))

    this.summaryToggle.setAttribute('role', 'button')
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open')
  }

  onSummaryClick(event) {
    event.preventDefault()
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event)
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false)
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
    event.target.closest('details').setAttribute('open', true)
    document.body.addEventListener('click', this.onBodyClickEvent)
    document.body.classList.add('overflow-hidden')
    this.classList.add('active')

    const overlay = document.querySelector('.search-modal .modal-overlay')

    if (overlay) {
      const colors = ['0, 46, 231', '198, 168, 255', '0, 217, 214', '255, 244, 66', '251, 61, 92']
      const color = colors[Math.floor(Math.random() * colors.length)]

      overlay.style.backgroundColor = `rgba(${color}, 0.9)`
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    )
  }

  close(focusToggle = true) {
    this.classList.remove('active')

    setTimeout(() => {
      removeTrapFocus(focusToggle ? this.summaryToggle : null)
      this.detailsContainer.removeAttribute('open')
      document.body.removeEventListener('click', this.onBodyClickEvent)
      document.body.classList.remove('overflow-hidden')
    }, 400)
  }
}

customElements.define('details-modal', DetailsModal)
